import { DASHBOARD_ACTIVTY } from "../actions";

export const dashboardActivity = (state = {}, action) => {
  if (action.type == DASHBOARD_ACTIVTY) return action.payload;
  return state;
};
